<template>
    <div
        id="pdfqleditor"
        class="ql-editor"
        :class="{ 'print-only-target': hide }"
        v-html="html"
    ></div>
</template>

<script>
// highlight.js style
import "highlight.js/styles/tomorrow.css";
// import theme style
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import dedent from "dedent";
import {ref, watch} from "vue";

export default {
    props: {
        value: String,
        hide: {type: Boolean, default: false},
    },
    setup(props) {
        const html = ref(null);

        watch(() => props.value, () => {
            if (props.value) {
                html.value = dedent`${props.value}`;
            }
        }, {immediate: true});

        return {
            html,
        }
    }
};
</script>

<style scoped>

/* Hide on screen, keep intact for the printer */
@media screen {
    .print-only-target {
        position: absolute !important;
        left: -9999px !important;
        top: -9999px !important;
        opacity: 0 !important;
        pointer-events: none !important;
        height: 0 !important;
        overflow: hidden !important;
    }
}



@media print {
    body {
        background: none;
    }
    .ql-editor {
        box-shadow: none;
        padding: 0;
        width: auto;
        min-height: auto;
    }
    .ql-editor hr.ql-page-break {
        page-break-before: always;
        break-before: page;
        visibility: hidden;
        margin: 0;
    }

    @page {
        size: A4;
        margin: 20mm;
    }

    .print-only-target {
        position: static !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        height: auto !important;
        overflow: visible !important;
    }
}


</style>